webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(19);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(15);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: 'body',
	  components: { App: _App2.default }
	});

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _RedirectTimer = __webpack_require__(17);
	
	var _RedirectTimer2 = _interopRequireDefault(_RedirectTimer);
	
	var _SocialList = __webpack_require__(18);
	
	var _SocialList2 = _interopRequireDefault(_SocialList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(5);
	__webpack_require__(6);
	exports.default = {
	  components: {
	    RedirectTimer: _RedirectTimer2.default,
	    SocialList: _SocialList2.default
	  },
	  data: function data() {
	    return {
	      socialItemList: {
	        email: {
	          service: 'mail',
	          url: 'mailto:nathan@ndchristie.com',
	          displayString: 'nathan@ndchristie.com'
	        },
	        skype: {
	          service: 'skype',
	          url: 'skype:unicornrsunshine?add',
	          displayString: 'unicornrsunshine'
	        },
	        linkedin: {
	          service: 'linkedin',
	          url: 'http://linkedin.com/in/ndchristie',
	          displayString: 'ndchristie'
	        },
	        instagram: {
	          service: 'instagram',
	          url: 'http://instagram.com/ndchristie/',
	          displayString: 'ndchristie'
	        }
	      }
	    };
	  },
	  attached: function attached() {
	    var sociconLink = document.createElement('link');
	    sociconLink.rel = 'stylesheet';
	    sociconLink.href = 'https://file.myfontastic.com/n6vo44Re5QaWo8oCKShBs7/icons.css';
	    document.getElementsByTagName('head')[0].appendChild(sociconLink);
	  }
	};

/***/ },
/* 2 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    noMessage: { type: String, default: 'no' },
	    yesMessage: { type: String, default: 'yes' }
	  },
	  methods: {
	    choose: function choose(choice) {
	      this.$dispatch('choose', choice);
	    }
	  }
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _BinaryChoice = __webpack_require__(16);
	
	var _BinaryChoice2 = _interopRequireDefault(_BinaryChoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timer = void 0;
	exports.default = {
	  components: {
	    BinaryChoice: _BinaryChoice2.default
	  },
	  props: {
	    url: {
	      type: String
	    },
	    updatesPerSecond: {
	      type: Number,
	      default: 1
	    },
	    timeRemaining: {
	      type: Number,
	      default: 30
	    }
	  },
	  methods: {
	    startTimer: function startTimer() {
	      var _this = this;
	
	      clearInterval(timer);
	      var startTime = window.performance.now() / 1000;
	      var duration = this.timeRemaining;
	      timer = setInterval(function () {
	        _this.timeRemaining = Math.ceil(startTime + duration - window.performance.now() / 1000);
	        if (_this.timeRemaining <= 0) {
	          window.location = _this.url;
	        }
	      }, 1000 / this.updatesPerSecond);
	    },
	    stopTimer: function stopTimer() {
	      clearInterval(timer);
	      var redirectInfo = document.getElementById('redirect-timer-info');
	      redirectInfo.parentNode.removeChild(redirectInfo);
	    }
	  },
	  events: {
	    choose: function choose(choice) {
	      if (choice === true) {
	        window.location = this.url;
	        return;
	      }
	      if (choice === false) {
	        this.stopTimer();
	        return;
	      }
	      return;
	    }
	  },
	  attached: function attached() {
	    this.startTimer();
	  }
	};

/***/ },
/* 4 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    itemList: {
	      type: Object
	    }
	  }
	};

/***/ },
/* 5 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 6 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 7 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 8 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 9 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */
/***/ function(module, exports) {

	module.exports = " <div id=app> <div class=card> <h1 class=\"header header--strong\"> Welcome to ndchristie.com </h1> <p class=paragraph>This domain has mutliple subdomains for different projects. This site serves primarily as the portal for those projects.</p> </div> <div class=card> <redirect-timer url=http://portfolio.ndchristie.com> </redirect-timer></div> <div class=card> <social-list v-bind:item-list=socialItemList></social-list> </div> <footer class=\"card card--well\"> <p class=\"paragraph paragraph--fineprint\">&copy; 2016 N.D.Christie</p> </footer> </div> ";

/***/ },
/* 12 */
/***/ function(module, exports) {

	module.exports = " <div class=binary-choice> <button id=binary-no class=\"binary-choice__item button\" v-on:click=choose(false)> {{noMessage}} </button> <button id=binary-yes class=\"binary-choice__item button button--encourage\" v-on:click=choose(true)> {{yesMessage}} </button> </div> ";

/***/ },
/* 13 */
/***/ function(module, exports) {

	module.exports = " <div class=redirect-timer> <p class=header>You may have been looking for <a class=text-link v-bind:href=url>{{url}}</a>.</p> <div id=redirect-timer-info class=redirect-timer__info> <p class=paragraph> You will be automatically redirected in <span id=redirect-timer-digits class=redirect-timer__digits>{{timeRemaining}}</span> seconds. </p> <binary-choice no-message=stop yes-message=\"go now\"></binary-choice> </div> </div> ";

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = " <div class=social-list> <p class=header>Get Connected</p> <ul class=stack-vertical> <li class=stack-vertical__item v-for=\"item in itemList\"> <span class=\"socicon--single socicon-{{item.service}}\"></span> <a v-bind:href=item.url class=text-link>{{item.displayString || item.url}}</a> </li></ul> </div> ";

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(7)
	__vue_script__ = __webpack_require__(1)
	__vue_template__ = __webpack_require__(11)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(8)
	__vue_script__ = __webpack_require__(2)
	__vue_template__ = __webpack_require__(12)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(9)
	__vue_script__ = __webpack_require__(3)
	__vue_template__ = __webpack_require__(13)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(10)
	__vue_script__ = __webpack_require__(4)
	__vue_template__ = __webpack_require__(14)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.5e2db28c965a81030aa2.js
 **/